// src/components/OpeningPage.tsx

import React, { useState } from 'react';
import { Button, Typography, Box, FormGroup, FormControlLabel, Checkbox, Stack, Grid } from '@mui/material';
import { useLevelUnit } from './context/LevelUnitContext';
import chineseData from './data/chineseData';

const OpeningPage: React.FC<{ onStart: () => void }> = ({ onStart }) => {
  const [showUnits, setShowUnits] = useState(false);
  const { setLevel, setUnit, isRandom, setIsRandom } = useLevelUnit();

  // Extract unique levels
  const levels = Array.from(new Set(chineseData.map(item => item.Level)));

  // Filter units by selected level
  const getUnits = (level: string) => {
    setShowUnits(true);
    setLevel(level);
    return chineseData.filter(item => item.Level === level).map(item => item.Unit);
  };

  // Render units as buttons
  const UnitsButtons = ({ level }: { level: string }) => {
    const uniqueUnits = Array.from(new Set(chineseData.filter(item => item.Level === level).map(item => item.Unit)));
    return (
      <Stack direction="column" spacing={1} sx={{ mt: 1 }}>
      <Grid container spacing={1}>
        {uniqueUnits.map(unit => (
        <Grid item xs={4} sm={4} md={2} lg={2} key={unit}>
          <Button variant="contained" onClick={() => { setUnit(unit); onStart(); }}>
          {unit}
          </Button>
        </Grid>
        ))}
      </Grid>
      </Stack>
    );
  };

  return (
    <Box sx={{ width: '90%', maxWidth: '600px', mt: 4, textAlign: 'center' }}>
      <Typography variant="h4" gutterBottom>PinYinTest</Typography>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
        <FormGroup>
          <FormControlLabel
            control={<Checkbox checked={isRandom} onChange={e => setIsRandom(e.target.checked)} />}
            label="Random Order"
          />
        </FormGroup>
      </Box>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
        {!showUnits ? (
          <Stack direction="row" spacing={2} justifyContent="center">
            {levels.map(level => (
              <Button key={level} variant="outlined" onClick={() => getUnits(level)}>
                {level}
              </Button>
            ))}
          </Stack>
        ) : (
          <UnitsButtons level={levels.find(lvl => lvl === levels[0]) || ''} />
        )}
      </Box>
    </Box>
  );
};

export default OpeningPage;
